<template>
  <div class="bg-white mt-20 tabs-palliative">
    <Banner />
    <div class="">
      <div class="mx-auto sticky">
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="tabs-bottom-none bdr-bottom-none"
        >
          <el-tab-pane label="About Palliative Care" name="first"></el-tab-pane>
          <el-tab-pane label="History" name="second"></el-tab-pane>
          <el-tab-pane
            label="Principals & Framework"
            name="third"
          ></el-tab-pane>
          <el-tab-pane label="Issues & Importance" name="fourth"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="lg:px-8 md:px-5 px-2 lg:pb-16 md:pb-12 pb-8">
        <!-- <div class="container mx-auto">
        <el-tabs
          v-model="activeName"
          @tab-click="handleClick"
          class="tabs-bottom-none bdr-bottom-none"
        >
          <el-tab-pane
            label="About Palliative Care"
            name="first"
            class="{ 'custom-active-tab': activeName === 'first' }"
            ><Pallative
          /></el-tab-pane>
          <el-tab-pane label="History" name="second"><History /></el-tab-pane>
          <el-tab-pane label="Principals & Framework" name="third"
            ><Principle
          /></el-tab-pane>
          <el-tab-pane label="Issues & Importance" name="fourth"
            ><Issues
          /></el-tab-pane>
        </el-tabs>
      </div> -->
        <div class="container relative lg:flex md:flex start-items">
          <div class="lg:w-10/12 md:w-10/12 w-full">
            <div v-if="activeName === 'first'">
              <Pallative />
            </div>
            <div v-else-if="activeName === 'second'">
              <History />
            </div>
            <div v-else-if="activeName === 'third'">
              <Principle />
            </div>
            <div v-else-if="activeName === 'fourth'">
              <Issues />
            </div>
          </div>
          <div
            class="border-left sticky-sidebar lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4"
          >
            <SideBlogs />
          </div>
        </div>
      </div>
      <PartnerOrganization />
      <Faq />
      <Newsletter />
      <Disclaimer />
    </div>
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import Pallative from "./Pallative.vue";
import History from "./History.vue";
import Principle from "./Principle.vue";
import Issues from "./Issues.vue";
import Nutrition from "./Nutrition.vue";
import FinancialSupport from "./FinancialSupport.vue";
import { mapState } from "vuex";
// Common
import PartnerOrganization from "./components/PartnerOrganization.vue";
import Faq from "./components/Faq.vue";
import Newsletter from "./components/Newsletter.vue";
import Disclaimer from "./components/Disclaimer.vue";
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    Banner,
    Pallative,
    History,
    Principle,
    Issues,
    Nutrition,
    FinancialSupport,
    //Common
    PartnerOrganization,
    Faq,
    Newsletter,
    Disclaimer,
    SideBlogs,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    handleClick() {
      document.documentElement.scrollTop = 700;
    },
    async getFaqData() {
      let payload = {
        category: "Palliative",
        // subcategory: tab.label,
        active: true,
      };
      await this.$store.dispatch("medicalFaq/getFilteredMedicalFaq", payload);
    },
  },
  computed: {
    ...mapState("medicalFaq", ["FilteredMedicalFaq"]),
  },
  async mounted() {
    // await this.handleClick({ label: "About Palliative Care" });
    await this.getFaqData();
  },
};
</script>
<style scoped>
/* Scoped styles using ::v-deep for deep selector */
::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
  height: 0px !important;
}

::v-deep .el-tabs__active-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 0pxn !important;
  background-color: transparent !important;
  z-index: 1;
  -webkit-transition: -webkit-transform 0.3s
    cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
    -webkit-transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  list-style: none;
}

::v-deep .el-tabs__header .el-tab {
  background-color: #f0f0f0;
  color: #333;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 8px;
  transition: background-color 0.3s ease;
}

::v-deep .el-tabs__item.is-active {
  color: #ffffff !important;
  background-color: #4f0a4b !important;
  border: 1px solid #4f0a4b !important;
}

::v-deep .el-tabs__item {
  padding: 0px 26px !important;
  margin-right: 15px !important;
  height: 38px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 38px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #4f4f4f;
  border: 1px solid #4f4f4f;
  position: relative;
  border-radius: 6px !important;
}

::v-deep .el-tabs__header .el-tab i {
  margin-right: 8px; /* Add some space between icon and text */
}

.sticky {
  position: sticky;
  top: 84px; /* Adjust for navbar height */
  z-index: 9;
  background-color: white; /* Ensure visibility */
}

.start-items {
  align-items: flex-start !important;
}
.sticky-sidebar {
  position: sticky;
  top: 130px;
  z-index: 8;
  /* max-height: calc(100vh - 130px); */
  max-height: fit-content;
  /* overflow-y: auto; */
  background-color: white; /* Ensure visibility */
}
</style>
